<template>
<div :class="{ 'dark-mode': darkMode, 'light-mode': !darkMode }"> <!-- Bind both classes -->
 

    <!-- Removed the old lamp-toggle -->
    
    <component :is="layout" @toggle-dark-mode="handleDarkModeToggle">
      <router-view></router-view>
    </component>
  </div>
</template>


<!-- ###################################################################### -->

<script>

const defaultLayout = "LayoutMain";

export default {
  data() {
    return {
      darkMode: false, // Initialize darkMode state
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout);
    },
    darkMode() {
    return this.$store.state.darkMode.darkMode;
  },
  darkMode() {
    return this.$store.state.darkMode.darkMode; // Access via namespace
  }
  },
  watch: {
  darkMode(newVal) {
    document.body.classList.toggle('dark-mode', newVal);
   // console.log('Dark Mode Toggled:', newVal);
  }
},
  methods: {
    toggleDarkMode() {
      this.darkMode = !this.darkMode; // Toggle the darkMode state

      document.body.classList.toggle('dark-mode', this.darkMode); // Toggle CSS class on body

      localStorage.setItem('darkMode', this.darkMode); // Persist user preference
    },
    toggleTheme() {
      this.toggleDarkMode(); // Reuse the existing toggleDarkMode method
    },
     handleDarkModeToggle(isDarkMode) {
      this.darkMode = isDarkMode;
      document.body.classList.toggle('dark-mode', this.darkMode);
      localStorage.setItem('darkMode', this.darkMode);
    }
  },
  created() {
    this.darkMode = localStorage.getItem('darkMode') === 'true';
    //console.log(this.$route, this.$route.meta.layout);
  },
  watch: {
    darkMode(newVal) {
     // console.log('Dark Mode Toggled:', newVal); // Debug log
    }
  },
  updated() {
    //console.log(this.$route, this.$route.meta.layout);
  }
}
</script>

<style>


/* Dark Mode Styles */
.dark-mode {
  background-color: #191919;
  color: #dedbdb;
}

/* Override table cell text color to white */
.dark-mode .el-table td,

.dark-mode .el-table .cell {
  background-color: #191919 !important; /* Dark background for table cells */

  color: #dedbdb !important;
}

/* Override table header text color to white */
.dark-mode .el-table__header .cell {
  color: #dedbdb !important;
}

/* Optional: Adjust header background color */

/* Ensure links inside tables are visible */
.dark-mode .el-table a {
  color: #11CDEF !important; /* Light purple for links */
}
/* Dark Mode Styles for Table Headers */
.dark-mode .el-table .el-table__header,
.dark-mode .el-table th,
.dark-mode .el-table thead .cell {
  background-color: #303B51 !important; /* Dark background for headers */
  color: #dedbdb !important;            /* White text for headers */
  border-color: #11CDEF !important;     /* Optional: Dark border for headers */
}

/* Optional: Adjust hover and active states for headers */
.dark-mode .el-table th:hover,
.dark-mode .el-table thead .cell:hover {
  background-color: #11CDEF !important; /* Slightly lighter dark background on hover */
}

/* Dark Mode Styles for Card Header */
.dark-mode .card-header {
  background-color: #191919 !important; /* Dark background */
  color: #dedbdb !important;            /* White text */
}

/* Optional: Adjust Border Colors */
.dark-mode .card-header {
  border-color: #11CDEF !important;     /* Dark border */
}

/* Ensure Nested Elements Inherit Colors */
.dark-mode .card-header * {
  color: #dedbdb !important;
}
.dark-mode .card-body {
  background-color: #191919 !important; /* Match the dark mode background */
  color: #dedbdb !important;           /* Light text for readability */
  border: 1px solid #444 !important;  /* Optional: Add a border for separation */
}
body.dark-mode {
  background-color: #191919 !important;
}
html, body, .wrapper, .main-content {
  min-height: 100vh;
}
/* Ensure child elements adapt to Dark Mode */
.dark-mode .layout-main,
.dark-mode .header,
.dark-mode .sidebar,
.dark-mode .main-content {
  background-color: #191919;
  color: #dedbdb;
}
.dark-mode .footer {
  background-color: #191919 !important;
}
/* Add smooth transition for theme change */
.dark-mode, .dark-mode-toggle {
  transition: background-color 0.3s ease, color 0.3s ease;
}
/* Override bg-secondary in Dark Mode */
.dark-mode .bg-secondary {
  background-color: #303B51 !important; /* Set to a dark background color */
  color: #dedbdb !important;            /* Ensure text color is light */
}
/* Dark Mode Input Styles */
.dark-mode input,
.dark-mode textarea,
.dark-mode select {
  background-color: #303B51 !important; /* Dark background for input fields */
  color: #dedbdb !important;           /* Light text for visibility */
  border: 1px solid #444 !important;   /* Optional: Add a border for better contrast */
  box-shadow: none !important;         /* Remove any box shadow for a flat appearance */
}

/* Placeholder Text */
.dark-mode input::placeholder,
.dark-mode textarea::placeholder {
  color: #888 !important; /* Lighter color for placeholder text */
}

/* Focus State */
.dark-mode input:focus,
.dark-mode textarea:focus,
.dark-mode select:focus {
  outline: none !important;
  border-color: #11CDEF !important;    /* Highlight border on focus */
  background-color: #1F2833 !important; /* Slightly darker background on focus */
}

</style>

